import { FolderIcon } from "@heroicons/react/outline";
import { AttachFile, SendSharp } from "@mui/icons-material";
import { FollowLeadSpinner } from "Component/Spinner";
import { fetchApi } from "Config/fetchApi";
import { getUserInfo } from "Config/getUserInfo";
import { handleError, useHeightObserver } from "Helper";
// import React, { useEffect, useRef, useState } from "react";
import React, { useEffect, useRef, useState } from "react";
import DynamicType from "./DynamicType";

const PlaygroundChat = () => {
  const chatRef = useRef(null);
  const heightObserver = useHeightObserver(chatRef);

  console.log(heightObserver)

  const [hasDataset, setHasDataset] = useState(false);
  const [generatingResponse, setGeneratingResponse] = useState(false);
  const [isTypeAnimating, setIsTypeAnimating] = useState(false);

  const [userPrompt, setUserPrompt] = useState("");
  const [chatHistory, setChatHistory] = useState([]);

  const scrollDown = () => {
    if (chatRef.current) {
      setTimeout(() => {
        chatRef.current.scrollTo({
          top: chatRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 50);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userPrompt) {
      setChatHistory((prev) => [
        ...prev,
        { from: "User", message: userPrompt },
      ]);
      setUserPrompt("");
      scrollDown();

      try {
        setGeneratingResponse(true);
        const resp = await fetchApi().post("/playground-prompt", {
          prompt: userPrompt,
        });
        const botResponse = resp?.data?.data || null;
        setChatHistory((prev) => [
          ...prev,
          { from: "Prompt", message: botResponse },
        ]);
      } catch (error) {
        handleError(error);
      } finally {
        setGeneratingResponse(false);
      }
    }
  };

  useEffect(() => {
    const getData = async () => {
      const userId = getUserInfo()?.userInfo?.id;
      const result = await fetchApi().get(`/intent/get-list/${userId}`);

      if (result?.data?.data?.length > 0) {
        setHasDataset(true);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    scrollDown();
  }, [heightObserver]);

  if (!hasDataset) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <FolderIcon className="text-blue-800 w-48" />
        <p className="text-lg w-96 text-center">
          Mohon untuk membuat dataset terlebih dahulu sebelum menggunakan
          Playground.
        </p>
      </div>
    );
  }

  console.log(getUserInfo().userInfo)
  const name = getUserInfo().userInfo.full_name
  const firstName = name.split(" ")?.[0] || name;

  return (
    <div className="flex flex-col w-full h-full">
      <div className="w-full h-full flex flex-col bg-white rounded-xl overflow-hidden">
        <div className="flex-1 overflow-hidden">
          <div className="relavite h-full">
            <div
              className="flex flex-col px-4-8 p-4 gap-4 h-full overflow-y-scroll"
              ref={chatRef}
            >
              {chatHistory.length <= 0 && <div className="w-full h-full text-3xl flex items-center justify-center gap-1">
                <img src="/asset/Logogram.png" alt="" className="w-16" />
                <div className="text-transparent font-bold bg-clip-text bg-gradient-to-br from-color-talangmas to-icon-folder/60">Hello, {firstName}</div>
              </div>}
              {chatHistory.map((el, i) => (
                <div
                  key={i}
                  className={`p-2 px-4 shrink-0 rounded-xl w-fit max-w-[75%] whitespace-pre-line ${
                    el.from === "User"
                      ? "self-end rounded-tr-none btn-color-talangmas text-white"
                      : "rounded-tl-none bg-blue-100 text-blue-800"
                  }`}
                >
                  {el.from === "User" ? (
                    el.message
                  ) : // Gunakan DynamicTypeAnimation untuk pesan dari bot
                  i === chatHistory.length - 1 ? (
                    <DynamicType
                      message={el.message}
                      // onAnimationStart={() => setIsTypeAnimating(true)}
                      // onAnimationEnd={() => setIsTypeAnimating(false)}
                    />
                  ) : (
                    el.message
                  )}
                </div>
              ))}

              {generatingResponse && (
                <div
                  className={`p-2 px-4 shrink-0 rounded-xl w-fit max-w-[75%] flex items-center rounded-tl-none bg-blue-100 text-blue-800 `}
                >
                  <FollowLeadSpinner size={4} color="#1e40af" />
                  <p className="-ml-2">Analyzing...</p>
                </div>
              )}
            </div>
          </div>
          {/* <div className="flex flex-col gap-4 w-full px-8 p-4 overflow-auto">
            {chatHistory.map((el) => {
              return (
                <div
                  className={`p-2 px-4 rounded-xl w-fit max-w-[75%] ${
                    el.from === "User"
                      ? "self-end rounded-tr-none btn-color-talangmas text-white"
                      : "rounded-tl-none bg-blue-100 text-blue-800"
                  }`}
                >
                  {el.message}
                </div>
              );
            })}
          </div> */}
        </div>
        <form
          className="p-4 gap-2 flex items-center w-full shrink-0 sticky bottom-0"
          onSubmit={handleSubmit}
        >
          <input
            placeholder="Type to start..."
            className="w-full border p-2 px-4 text-sm rounded-lg"
            value={userPrompt}
            disabled={generatingResponse || isTypeAnimating}
            onChange={(e) => setUserPrompt(e.target.value)}
          />
          <button
            type="submit"
            disabled={generatingResponse || isTypeAnimating}
          >
            <SendSharp className="text-blue-800 text-6 disabled:text-neutral-300" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default PlaygroundChat;
